import { Component, OnInit, Inject } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { API_BASE_URL_SERVICE } from '../../../../projects/kiene-core/src/lib/kiene-core.config';
import {
    FilterItem,
    FilterItemType,
} from '../../../../projects/kiene-core/src/lib/services/backend-api/classes/filter-item';
import { MessageService } from '../../../../projects/kiene-core/src/lib/services/message-service/message.service';
import { ConfirmDeleteDialogComponent } from '../../dialogs/confirm-delete-dialog/confirm-delete-dialog.component';
import { KieneTableService } from '../../components/kiene-table/kiene-table.service';
import { KieneBooleanTableColumn, TableColumn } from '../../components/kiene-table/table-column';
import { TableDescriptor } from '../../components/kiene-table/table-descriptor';
import { TableOption } from '../../components/kiene-table/table-option';
import { FibuErloesSuffix } from './fibu-erloes-suffix';
import { FibuErloesSuffixDialogComponent } from './fibu-erloes-suffix-dialog/fibu-erloes-suffix-dialog.component';

@Component({
    selector: 'kiene-erloes-suffixe',
    templateUrl: './erloes-suffixe.component.html',
    styleUrls: ['./erloes-suffixe.component.scss'],
})
export class ErloesSuffixeComponent implements OnInit {
    tableDescriptor: TableDescriptor = new TableDescriptor();

    constructor(
        private dialog: MatDialog,
        private api: KieneTableService,
        private messageService: MessageService,
        @Inject(API_BASE_URL_SERVICE) private apiBaseUrl: string,
    ) {}

    ngOnInit(): void {
        this.tableDescriptor.headline = 'Erlös-Suffixe (LIVE ab 1.1.2027)';
        this.tableDescriptor.uniqueIdentifier = 'FibuErloesSuffixe';
        this.tableDescriptor.apiUrl = this.apiBaseUrl + 'fibu_erloes_suffix/';
        this.tableDescriptor.route = '/finanzen/kontenrahmen/erloes-suffixe/';
        this.tableDescriptor.nameOfIdField = 'fibu_erloes_suffix_id';
        this.tableDescriptor.searchPlaceholder =
            'Suffix, Bezeichnung oder Betriebsart – Live erst ab 1.1.2027';
        this.tableDescriptor.createAllowed = true;
        this.tableDescriptor.standardCreate = false;
        this.tableDescriptor.addVoid = this.openDialog.bind(this);
        this.tableDescriptor.showDetails = false;
        this.tableDescriptor.showDetailsVoid = this.openDialog.bind(this);
        this.tableDescriptor.permissionView = 17010;
        this.tableDescriptor.permissionCreate = 17010;
        this.tableDescriptor.initialSortColumn = 'sortierung';
        this.tableDescriptor.initialSortDirection = 'asc';

        this.tableDescriptor.columns = [
            new TableColumn('suffix', 'Suffix'),
            new TableColumn('beispiel_praxis', 'Praxis 8401.x'),
            new TableColumn('beispiel_labor', 'Labor 8402.x'),
            new TableColumn('bezeichnung', 'Bezeichnung'),
            new TableColumn('betriebsart', 'Betriebsart'),
            new TableColumn('sortierung', 'Sort.'),
            new KieneBooleanTableColumn('aktiv', 'Aktiv'),
        ];

        this.tableDescriptor.options.push(
            new TableOption(this.openDialog.bind(this), 'Editieren', 'edit', 17010),
        );
        this.tableDescriptor.options.push(
            new TableOption(this.confirmAndDelete.bind(this), 'Löschen', 'delete', 17010),
        );

        this.tableDescriptor.filterItems.push(
            new FilterItem('Aktiv', '1', FilterItemType.CHECKBOX, 'aktiv', false),
        );
        this.tableDescriptor.filterItems.push(
            new FilterItem('Inaktiv', '0', FilterItemType.CHECKBOX, 'aktiv', false),
        );
    }

    openDialog(row?: FibuErloesSuffix) {
        const dialogRef = this.dialog.open(FibuErloesSuffixDialogComponent, {
            width: '560px',
            maxHeight: '90vh',
            data: { row: row ? { ...row } : null },
        });
        dialogRef.afterClosed().subscribe(saved => {
            if (saved) {
                this.api.reload();
            }
        });
    }

    confirmAndDelete(row: FibuErloesSuffix) {
        const dialogRef = this.dialog.open(ConfirmDeleteDialogComponent, {
            data: {
                title: 'Erlös-Suffix löschen',
                text: `Suffix ${row.suffix} (${row.bezeichnung}) wirklich löschen?`,
            },
        });
        dialogRef.afterClosed().subscribe(ok => {
            if (!ok) {
                return;
            }
            this.api.deleteEntity(this.apiBaseUrl + 'fibu_erloes_suffix/delete.php', row).subscribe({
                next: () => {
                    this.messageService.infoMessage('Suffix gelöscht.');
                    this.api.reload();
                },
                error: err => {
                    this.messageService.errorMessage('Löschen fehlgeschlagen.', err);
                    this.api.reload();
                },
            });
        });
    }
}
